/**
 * from https://gist.github.com/jsprpalm/12217feab2f1acc14bd8e8508291619e
 * @param pdfViewer
 */
export const enablePinchZoom = (viewerScale, setViewerScale, initialScale) => {
  let startX = 0,
    startY = 0,
    translateX = 0,
    translateY = 0
  let initialPinchDistance = 0
  let pinchScale = 1
  const viewer = document.getElementById('viewerWrapper')
  const container = document.getElementById('viewerContainer')
  const reset = () => {
    startX = startY = translateX = translateY = initialPinchDistance = 0
    pinchScale = 1
  }

  // Prevent native iOS page zoom
  const listener1 = (e: TouchEvent) => {
    // @ts-expect-error scale is on iOS events I assume
    if (e.touches.length > 1 && e.scale !== 1) {
      e.preventDefault()
    }
  }
  document.addEventListener('touchmove', listener1, { passive: false })

  const listener2 = (e: TouchEvent) => {
    if (e.touches.length > 1) {
      startX = (e.touches[0].clientX + e.touches[1].clientX) / 2
      startY = (e.touches[0].clientY + e.touches[1].clientY) / 2
      initialPinchDistance = Math.hypot(
        e.touches[1].clientX - e.touches[0].clientX,
        e.touches[1].clientY - e.touches[0].clientY
      )
    } else {
      initialPinchDistance = 0
    }
  }
  viewer.addEventListener('touchstart', listener2)

  const listener3 = (e: TouchEvent) => {
    if (initialPinchDistance <= 0 || e.touches.length < 2) {
      return
    }

    const pinchDistance = Math.hypot(
      e.touches[1].clientX - e.touches[0].clientX,
      e.touches[1].clientY - e.touches[0].clientY
    )
    const originX = startX + container.scrollLeft
    const originY = startY + container.scrollTop
    pinchScale = pinchDistance / initialPinchDistance

    // handle pinch and drag
    const currentX = (e.touches[0].clientX + e.touches[1].clientX) / 2
    const currentY = (e.touches[0].clientY + e.touches[1].clientY) / 2
    translateX = currentX - startX
    translateY = currentY - startY

    viewer.style.transformOrigin = `${originX}px ${originY}px`
    viewer.style.transform = `scale(${pinchScale}) translate(${translateX}px, ${translateY}px)`
  }
  viewer.addEventListener('touchmove', listener3)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const listener4 = () => {
    if (initialPinchDistance <= 0) {
      return
    }

    viewer.style.transform = `none`
    viewer.style.transformOrigin = `unset`

    const effectiveScale = viewerScale * pinchScale
    const initialPinchScale = initialScale / viewerScale

    if (effectiveScale < initialScale) {
      setViewerScale?.(initialScale)
    } else {
      setViewerScale?.(effectiveScale)
    }

    const rect = container.getBoundingClientRect()
    const dx = startX - rect.left
    const dy = startY - rect.top
    container.scrollLeft += dx * (pinchScale - 1) - translateX
    container.scrollTop +=
      effectiveScale < initialScale
        ? dx * (initialPinchScale - 1)
        : dy * (pinchScale - 1) - translateY

    reset()
  }
  container.addEventListener('touchend', listener4)

  return () => {
    document.removeEventListener('touchmove', listener1)
    viewer.removeEventListener('touchstart', listener2)
    viewer.removeEventListener('touchmove', listener3)
    container.removeEventListener('touchend', listener4)
  }
}
